// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISaveCarrierConfigDto
 */
export interface ISaveCarrierConfigDto {
    /**
     * 
     * @type {string}
     * @memberof ISaveCarrierConfigDto
     */
    carrier_external_id: string;
    /**
     * 
     * @type {number}
     * @memberof ISaveCarrierConfigDto
     */
    organization_id: number;
    /**
     * 
     * @type {string}
     * @memberof ISaveCarrierConfigDto
     */
    organization_path: string;
    /**
     * 
     * @type {string}
     * @memberof ISaveCarrierConfigDto
     */
    submitter_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ISaveCarrierConfigDto
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ISaveCarrierConfigDto
     */
    service_date_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ISaveCarrierConfigDto
     */
    service_date_to?: Date;
    /**
     * 
     * @type {string}
     * @memberof ISaveCarrierConfigDto
     */
    purpose_type?: ISaveCarrierConfigDtoPurposeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ISaveCarrierConfigDto
     */
    claim_autopay_type?: ISaveCarrierConfigDtoClaimAutopayTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ISaveCarrierConfigDto
     */
    is_dependent_deidentified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ISaveCarrierConfigDto
     */
    is_dependent_autocreated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ISaveCarrierConfigDto
     */
    status_type?: ISaveCarrierConfigDtoStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ISaveCarrierConfigDto
     */
    claim_payee_type?: ISaveCarrierConfigDtoClaimPayeeTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ISaveCarrierConfigDto
     */
    amount_types?: Array<ISaveCarrierConfigDtoAmountTypesEnum>;
}

/**
* @export
* @enum {string}
*/
export enum ISaveCarrierConfigDtoPurposeTypeEnum {
    CLAIM_CREATION = 'CLAIM_CREATION',
    ADJUDICATION = 'ADJUDICATION'
}
/**
* @export
* @enum {string}
*/
export enum ISaveCarrierConfigDtoClaimAutopayTypeEnum {
    AUTO = 'AUTO',
    CLICK = 'CLICK',
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE'
}
/**
* @export
* @enum {string}
*/
export enum ISaveCarrierConfigDtoStatusTypeEnum {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED'
}
/**
* @export
* @enum {string}
*/
export enum ISaveCarrierConfigDtoClaimPayeeTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER',
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE'
}
/**
* @export
* @enum {string}
*/
export enum ISaveCarrierConfigDtoAmountTypesEnum {
    COINSURANCE = 'COINSURANCE',
    COPAY = 'COPAY',
    PATIENT_RESPONSIBILITY = 'PATIENT_RESPONSIBILITY',
    DEDUCTIBLE = 'DEDUCTIBLE',
    MIXED = 'MIXED'
}


/**
 * Check if a given object implements the ISaveCarrierConfigDto interface.
 */
export function instanceOfISaveCarrierConfigDto(value: object): value is ISaveCarrierConfigDto {
    if (!('carrier_external_id' in value) || value['carrier_external_id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('organization_path' in value) || value['organization_path'] === undefined) return false;
    return true;
}

export function ISaveCarrierConfigDtoFromJSON(json: any): ISaveCarrierConfigDto {
    return ISaveCarrierConfigDtoFromJSONTyped(json, false);
}

export function ISaveCarrierConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISaveCarrierConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'carrier_external_id': json['carrier_external_id'],
        'organization_id': json['organization_id'],
        'organization_path': json['organization_path'],
        'submitter_id': json['submitter_id'] == null ? undefined : json['submitter_id'],
        'description': json['description'] == null ? undefined : json['description'],
        'service_date_from': json['service_date_from'] == null ? undefined : (new Date(json['service_date_from'])),
        'service_date_to': json['service_date_to'] == null ? undefined : (new Date(json['service_date_to'])),
        'purpose_type': json['purpose_type'] == null ? undefined : json['purpose_type'],
        'claim_autopay_type': json['claim_autopay_type'] == null ? undefined : json['claim_autopay_type'],
        'is_dependent_deidentified': json['is_dependent_deidentified'] == null ? undefined : json['is_dependent_deidentified'],
        'is_dependent_autocreated': json['is_dependent_autocreated'] == null ? undefined : json['is_dependent_autocreated'],
        'status_type': json['status_type'] == null ? undefined : json['status_type'],
        'claim_payee_type': json['claim_payee_type'] == null ? undefined : json['claim_payee_type'],
        'amount_types': json['amount_types'] == null ? undefined : json['amount_types'],
    };
}

export function ISaveCarrierConfigDtoToJSON(json: any): ISaveCarrierConfigDto {
    return ISaveCarrierConfigDtoToJSONTyped(json, false);
}

export function ISaveCarrierConfigDtoToJSONTyped(value?: ISaveCarrierConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'carrier_external_id': value['carrier_external_id'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'submitter_id': value['submitter_id'],
        'description': value['description'],
        'service_date_from': value['service_date_from'] == null ? undefined : ((value['service_date_from']).toISOString()),
        'service_date_to': value['service_date_to'] == null ? undefined : ((value['service_date_to']).toISOString()),
        'purpose_type': value['purpose_type'],
        'claim_autopay_type': value['claim_autopay_type'],
        'is_dependent_deidentified': value['is_dependent_deidentified'],
        'is_dependent_autocreated': value['is_dependent_autocreated'],
        'status_type': value['status_type'],
        'claim_payee_type': value['claim_payee_type'],
        'amount_types': value['amount_types'],
    };
}

